import { useEffect, useState } from 'react';
import { api, uid, ApiError } from '../lib/api';
import { useToast } from '../context/ToastContext';
import type { Client } from './Clients';

export function Losses() {
  const toast = useToast();
  const [clients, setClients] = useState<Client[]>([]);
  const [cat, setCat] = useState('internal');
  const [clientId, setClientId] = useState('');
  const [pm, setPm] = useState('');
  const [gm, setGm] = useState('');
  const [note, setNote] = useState('');
  const [ref, setRef] = useState('');
  const [msg, setMsg] = useState<{ text: string; err: boolean } | null>(null);

  useEffect(() => { api<Client[]>('/v1/clients').then(setClients).catch(() => {}); }, []);

  async function submit(e: React.FormEvent) {
    e.preventDefault();
    const quantities: Record<string, number> = {};
    if (+pm > 0) quantities.PM = +pm;
    if (+gm > 0) quantities.GM = +gm;
    if (!Object.keys(quantities).length) { setMsg({ text: 'Indiquez au moins une quantité.', err: true }); return; }
    const body: Record<string, unknown> = { category: cat, quantities, note: note.trim(), ref: ref.trim() || uid() };
    if (cat === 'client') {
      if (!clientId) { setMsg({ text: 'Choisissez un client.', err: true }); return; }
      body.client_id = clientId;
    }
    try {
      const r = await api<{ queued?: true }>('/v1/losses', {
        method: 'POST', body, offlineQueue: true, queueKind: 'loss', queueLabel: `Perte (${cat})`,
      });
      if (r.queued) {
        setMsg({ text: 'Hors ligne — perte enregistrée, sera synchronisée automatiquement.', err: false });
        toast('Perte mise en attente (hors ligne)');
      } else {
        setMsg({ text: 'Perte déclarée.', err: false });
        toast('Perte déclarée');
      }
    } catch (e) { setMsg({ text: e instanceof ApiError ? e.message : 'Erreur', err: true }); }
  }

  return (
    <>
      <div className="pagehead"><h1>Pertes</h1></div>
      <div className="card">
        <h2>Déclarer une perte</h2>
        <form onSubmit={submit}>
          <label>Catégorie</label>
          <select value={cat} onChange={(e) => setCat(e.target.value)}>
            <option value="internal">Interne (stock central)</option>
            <option value="marjane">Marjane</option>
            <option value="client">Client</option>
          </select>
          {cat === 'client' && (
            <>
              <label>Client</label>
              <select value={clientId} onChange={(e) => setClientId(e.target.value)}>
                <option value="">—</option>
                {clients.map((c) => <option key={c.id} value={c.id}>{c.name}</option>)}
              </select>
            </>
          )}
          <div className="row2">
            <div><label>Quantité PM</label><input type="number" min={0} value={pm} onChange={(e) => setPm(e.target.value)} /></div>
            <div><label>Quantité GM</label><input type="number" min={0} value={gm} onChange={(e) => setGm(e.target.value)} /></div>
          </div>
          <label>Note</label>
          <input value={note} onChange={(e) => setNote(e.target.value)} placeholder="motif de la perte" />
          <label>Référence (optionnel)</label>
          <input value={ref} onChange={(e) => setRef(e.target.value)} />
          <div className="row" style={{ marginTop: '0.8rem' }}><button type="submit" className="primary">Déclarer la perte</button></div>
          {msg && <div className={msg.err ? 'err' : 'ok'}>{msg.text}</div>}
        </form>
      </div>
    </>
  );
}
